import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'contractor', label: 'Contractor' },
  { value: 'homeowner', label: 'Homeowner' },
];

const ROLE_PATHS = { admin: '/admin', contractor: '/contractor', homeowner: '/homeowner' };

const RoleSwitcherBar = () => {
  const { user, effectiveRole, setEffectiveRole } = useAuth();
  const navigate = useNavigate();

  if (user?.role !== 'admin') return null;

  const handleSwitch = (role) => {
    setEffectiveRole(role);
    navigate(ROLE_PATHS[role]);
  };

  return (
    <Box
      sx={{
        bgcolor: '#1a1a2e',
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexWrap: 'wrap',
      }}
    >
      <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)', mr: 0.5, whiteSpace: 'nowrap' }}>
        View as:
      </Typography>
      {ROLES.map(opt => (
        <Chip
          key={opt.value}
          label={opt.label}
          size="small"
          onClick={() => handleSwitch(opt.value)}
          sx={{
            fontWeight: effectiveRole === opt.value ? 700 : 400,
            cursor: 'pointer',
            bgcolor: effectiveRole === opt.value ? '#3b82f6' : 'rgba(255,255,255,0.1)',
            color: 'white',
            border: effectiveRole === opt.value ? 'none' : '1px solid rgba(255,255,255,0.2)',
            '&:hover': { bgcolor: effectiveRole === opt.value ? '#2563eb' : 'rgba(255,255,255,0.2)' },
          }}
        />
      ))}
    </Box>
  );
};

export default RoleSwitcherBar;
